module.exports = __webpack_public_path__ + "static/media/arrow-left-s-line.1f50bb19.svg";